import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { DeviceService } from '@helpers/device.service';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { AppState } from '@app/ngrx/app-state/app-state';
import {
  getSavedSearchCollection, getSavedSearchLoaded,
  getSavedSearchLoading
} from '@app/ngrx/saved-search/states/saved-search-getters.state';
import { getSearch, removeSearch } from '@app/ngrx/saved-search/actions';
import {
  CreateProfileConfigForDeviceUuidParams,
  DeleteProfileConfigByIdAndDeviceUuidParams,
  DeleteProfileConfigByIdAndDeviceUuidResp,
  GetProfileConfigByDeviceUuidResp,
} from '@app/home/services/models/profile.model';

@Injectable({
  providedIn: 'root',
})
export class ProfileService {
  private readonly URL: string = `${environment.apiUserManagerUrl}/open-api/profile-config`;

  savedSearchCollection$: Observable<GetProfileConfigByDeviceUuidResp> = this.store.select(getSavedSearchCollection);
  savedSearchLoading$: Observable<boolean> = this.store.select(getSavedSearchLoading);
  savedSearchLoaded$: Observable<boolean> = this.store.select(getSavedSearchLoaded);

  constructor(
    private deviceService: DeviceService,
    private http: HttpClient,
    private store: Store<AppState>,
  ) {}

  getSearchList() {
    this.store.dispatch(getSearch());
  }

  public fetchSearchList(): Observable<GetProfileConfigByDeviceUuidResp> {
    return this.deviceService.getDeviceUUID().pipe(switchMap((uuid) => this.http.get<GetProfileConfigByDeviceUuidResp>(`${environment.apiUserManagerUrl}/open-api/profile-config/${uuid}`)));
  }

  removeSearch(id: number) {
    this.store.dispatch(removeSearch({ id }));
  }

  public removeSearchSetting(id: DeleteProfileConfigByIdAndDeviceUuidParams['id']): Observable<HttpResponse<DeleteProfileConfigByIdAndDeviceUuidResp>> {
    return this.deviceService.getDeviceUUID().pipe(switchMap((uuid) => this.http.get<DeleteProfileConfigByIdAndDeviceUuidResp>(`${this.URL}/delete/${id}/${uuid}`, { observe: 'response' })));
  }

  public saveSearchSetting(body: CreateProfileConfigForDeviceUuidParams) {
    return this.deviceService.getDeviceUUID().pipe(switchMap((uuid) => this.http.post(`${this.URL}`, { ...body, deviceUuid: uuid }, { observe: 'response' })));
  }
}
